// src/components/GoogleAuth.js
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const GoogleAuth = ({ onLoginSuccess }) => {
  const responseGoogle = (response) => {
    if (response.credential) {
      // Send the ID token to the server for verification
      onLoginSuccess(response.credential);
    } else {
      console.error("Google login failed");
    }
  };

  return (
    <div>
      <GoogleLogin
        onSuccess={responseGoogle}
        onError={() => console.log('Login Failed')}
      />
    </div>
  );
};

export default GoogleAuth;
